import { useState, useRef, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import { useSelector, useDispatch } from 'react-redux';
import strFunc from '@/lib/lyg/string';
import DatePicker from "react-datepicker";
import { ko } from "date-fns/esm/locale";
import DateFunc from '@/lib/lyg/date_func';
import { customHeaderFunc } from '@/pcomponents/common/date_picker/custom_header';
import { CustomInputWrite } from '@/pcomponents/common/date_picker/custom_input';
import FileListWriteFrame from '@/pages/comp/basic/file/frame/write';
import WriteInputFrame from '@/pages/comp/basic/file/frame/write_input';
import getXcolumnJson from "./xcolumn/list";
import TextAreaComponent from "@/pcomponents/common/crud/write/textarea";
import TimeInputComponent from "@/pcomponents/common/crud/write/time_input";
import SelectBoxBar from "@/pcomponents/common/crud/write/select_box_bar";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';

function WriteArea(props: any) {
  let myProps = {
    select_mcomp_data:{
      mcomp_seq: "",
      api_key: "",
      api_user_seq: "",
    },
    stu_info: {},
    par_id: "",
    par_seq: "",
    select_date: DateFunc.get_date_format(new Date(), "Y-m-d"),
    Style: {},
    list: (inData: any) => { },
    isUpdate: false,
    set_is_view_write: (inData: any) => { },
    ...props
  };
  let select_mcomp_data= myProps.select_mcomp_data;
  let Style = myProps.Style;
  const xColumnArr = getXcolumnJson();
  let user = useSelector((state: any) => state.user);
  const fileWriteOneRef = useRef<any>(null);
  const FileListWriteFrameRef = useRef<any>(null);
  const [isUpdate, setIsUpdate] = useState(myProps.isUpdate);
  const pageData = {
    "write_btn_text": "등록",
    "confirm_msg": "등록 하시겠습니까?",
  };
  if (isUpdate) {
    pageData["write_btn_text"] = "수정";
    pageData["confirm_msg"] = "수정 하시겠습니까?";
  }
  let select_arr_a_kind: any = XcolumnFunc.getSortByTableKey({ 'table': 'counsel_todo', 'key': 'a_kind' });
  let select_arr_eval_score = [
    { "value": "100", "text": "A" },
    { "value": "80", "text": "B" },
    { "value": "60", "text": "C" },
    { "value": "40", "text": "D" },
    { "value": "20", "text": "E" },
  ];
  const init_data = {
    "a_ymd": DateFunc.get_date_format(new Date(), "Ymd"),
    "a_seq": "",
    "a_stu_seq": myProps.stu_info["a_seq"],
    "a_stu_name": myProps.stu_info["a_user_name"],
    "a_par_id": myProps.par_id,
    "a_par_seq": myProps.par_seq,
    "a_sort1": "",
    "a_sort2": "",
    "a_kind": "",
    "a_feedback": "",
    "a_eval_score": "",
    "a_reference": "",
    "a_reserve_time": "00:00:00",

    "a_counsel_date": myProps.select_date,
    "a_reserve_date": myProps.select_date,
    "a_writer_seq": user.user_seq,
    "a_writer": user.user_name,
    "a_counseler_seq": user.user_seq,
    "a_counseler": user.user_name,
    "a_title": "상담",
    "a_content": "",
    "a_is_success": "1",
    "a_state": "complete",
  };
  const [rowData, setRowData] = useState({
    ...init_data
  });

  useEffect(() => {
    
  }, []);

  const handleInputChange = (event: any) => {
    const target = event.target;
    let value = target.value;
    const name = target.name;
    if (target.type === 'checkbox') {
      value = "";
      if (target.checked) {
        value = target.value;
      }
    }
    //a_state

    let change_row_data: any = { ...rowData };
    if (name == "a_state") {
      if (value == "complete") {
        change_row_data["a_is_success"] = "1";
        if (strFunc.is_empty(change_row_data["a_counsel_date"])) {
          change_row_data["a_counsel_date"] = DateFunc.get_date_format(new Date(), "Y-m-d");
        }
      } else {
        change_row_data["a_is_success"] = "";
      }
    }

    change_row_data[name] = value;
    setRowData(change_row_data);
  };
  const onChangeDatePicker = (key: string, date: Date) => {
    let date_str = DateFunc.get_date_format(date, "Y-m-d");
    setRowData({
      ...rowData,
      ...{ [key]: date_str }
    });
  };

  const goWrite = (e: any) => {
    if (rowData.a_stu_seq == "") {
      alert("원생 선택이 필요합니다.");
      return false;
    }
    if (rowData.a_title == "") {
      alert("제목 입력이 필요합니다.");
      return false;
    }
    if (!confirm(pageData["confirm_msg"])) {
      return false;
    }

    let wRowData = { ...rowData };
    if (!isUpdate) {
      wRowData["a_ymd"] = strFunc.str_replace("-", "", wRowData["a_reserve_date"]);
    }
    let formJsonData:any = {
      "data_arr": [wRowData],
      "is_default_val": "1",
      "is_update": "",
    };
    if (isUpdate) {
      formJsonData["is_default_val"] = "";
      formJsonData["is_update"] = "1";
    }
    if(!strFunc.is_empty(select_mcomp_data.api_key)
      &&!strFunc.is_empty(select_mcomp_data.api_user_seq)){
        formJsonData["api_key"]=select_mcomp_data.api_key;
        formJsonData["api_user_seq"]=select_mcomp_data.api_user_seq;
    }
    my_axios.post(process.env.REACT_APP_API_URL + '/api/comp/edu/counsel_todo/write', formJsonData,get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          alert("저장 하였습니다.");
          if (fileWriteOneRef.current) {
            let childFileInput = fileWriteOneRef.current.getFileInput();
            if (childFileInput.current.value == "") {
              props.list({});
            } else {
              let priVal = response.data["data"][0]["a_ymd"] + "," + response.data["data"][0]["a_seq"];
              fileWriteOneRef.current.goWrite({
                "a_par_seq": priVal
              });
            }
          } else {
            props.list({});
          }
        } else {
          alert(response.data["msg"]);
        }
      });

  };

  return (
    <div className={Style.write_wrap}>
      <div>상담 작성</div>
      <div className="write_table_small mt-1">
        <table>
          <colgroup>
            <col width="20%"></col>
            <col width="30%"></col>
            <col width="20%"></col>
            <col width="30%"></col>
          </colgroup>
          <tbody>
            <tr>
              <th>원생</th>
              <td colSpan={3}>
                {rowData.a_stu_name}

                <span className="ml-2">
                  <select className="row-input" name="a_state" value={rowData.a_state}
                    onChange={handleInputChange}
                    style={{ width: 60 }}>
                    <option value="ready">준비</option>
                    <option value="complete">완료</option>
                  </select>
                </span>

                <div className="ml-2" style={{ display: "inline-block" }}>
                  <SelectBoxBar
                    valueTextArr={select_arr_a_kind}
                    value={rowData.a_kind}
                    name={"a_kind"}
                    on_change={(inData: any) => {
                      handleInputChange({
                        target: {
                          name: inData.name,
                          value: inData.value,
                        }
                      });
                    }}
                  ></SelectBoxBar>
                </div>
              </td>
            </tr>
            <tr>
              <th>상담예정</th>
              <td>
                <DatePicker
                  selected={rowData.a_reserve_date != "" ? new Date(rowData.a_reserve_date) : null}
                  onChange={(date: Date) => {
                    onChangeDatePicker("a_reserve_date", date);
                  }}
                  locale={ko}
                  dateFormat="yyyy-MM-dd"
                  customInput={<CustomInputWrite />}
                  renderCustomHeader={customHeaderFunc}
                />
              </td>
              <th>상담일</th>
              <td>
                <DatePicker
                  selected={rowData.a_counsel_date != "" ? new Date(rowData.a_counsel_date) : null}
                  onChange={(date: Date) => {
                    onChangeDatePicker("a_counsel_date", date);
                  }}
                  locale={ko}
                  dateFormat="yyyy-MM-dd"
                  customInput={<CustomInputWrite />}
                  renderCustomHeader={customHeaderFunc}
                />
              </td>
            </tr>
            <tr>
              <th>예정시간</th>
              <td>
                <TimeInputComponent
                  name={"a_reserve_time"}
                  value={rowData.a_reserve_time}
                  on_change={(inData: any) => {
                    handleInputChange({
                      target: {
                        name: inData.name,
                        value: inData.value,
                      }
                    });
                  }}
                ></TimeInputComponent>
              </td>
              <th>평가</th>
              <td>
                <SelectBoxBar
                  valueTextArr={select_arr_eval_score}
                  value={rowData.a_eval_score}
                  name={"a_eval_score"}
                  on_change={(inData: any) => {
                    handleInputChange({
                      target: {
                        name: inData.name,
                        value: inData.value,
                      }
                    });
                  }}
                ></SelectBoxBar>
              </td>
            </tr>
            <tr>
              <th style={{fontSize:"11px"}}>상담내용</th>
              <td colSpan={3}>
                <TextAreaComponent
                  name={"a_content"}
                  value={rowData["a_content"]}
                  class_name={"row-input"}
                  style={{ "width": "100%" }}
                  onChange={handleInputChange}
                  placeholder={"상담내용"}
                ></TextAreaComponent>
              </td>
            </tr>
            <tr>
              <th>피드백</th>
              <td colSpan={3}>
                <div>
                  <TextAreaComponent
                    name={"a_feedback"}
                    value={rowData["a_feedback"]}
                    class_name={"row-input"}
                    style={{ "width": "100%" }}
                    onChange={handleInputChange}
                    placeholder={"피드백"}
                  ></TextAreaComponent>
                </div>
              </td>
            </tr>
            <tr>
              <th style={{fontSize:"11px"}}>참고내용</th>
              <td colSpan={3}>
                <div>
                  <TextAreaComponent
                    name={"a_reference"}
                    value={rowData["a_reference"]}
                    class_name={"row-input"}
                    style={{ "width": "100%" }}
                    onChange={handleInputChange}
                    placeholder={"참고내용"}
                  ></TextAreaComponent>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      {
        rowData.a_seq == "" &&
        <WriteInputFrame
          ref={fileWriteOneRef}
          select_mcomp_data={{...select_mcomp_data}}
          init_data={{
            a_par_id: xColumnArr.table,
            a_par_seq: rowData.a_ymd + "," + rowData.a_seq,
          }}
          callback={() => {
            props.list({});
          }}
        ></WriteInputFrame>
      }
      <div className="btn-box-center mt-2">
        <button className="btn btn-line-gray" onClick={goWrite}>{pageData["write_btn_text"]}</button>
        <button className="btn btn-line-gray" onClick={() => { myProps.set_is_view_write(false); }}>닫기</button>
      </div>
      {
        rowData.a_seq != "" &&
        <FileListWriteFrame
          ref={FileListWriteFrameRef}
          select_mcomp_data={{...select_mcomp_data}}
          listOpt={
            {
              s_par_id: xColumnArr.table,
              s_par_seq: rowData.a_ymd + "," + rowData.a_seq,
              s_start_date: rowData.a_reserve_date
            }
          }
          callback={(inData: any) => { myProps.list({}); }}
        ></FileListWriteFrame>
      }
    </div>
  );
};
export default WriteArea;